Ext.define('SA.CrosstabBodyCell', {
    extend: 'SA.TableCell',

    statics: {
        formatPercent(value) {
            return value === 100 ? '100%' : `${value.toFixed(1)}%`;
        }
    },

    constructor() {
        this.callParent(arguments);

        this.el.classList.add('sa-crosstab-body-cell-td');

        this.childEl = this.el.appendChild(document.createElement('div'));
        this.childEl.className = 'sa-crosstab-body-cell';

        this.loadingCell = new SA.CrosstabLoadingCell({parent: this.childEl});
        this.defaultCell = new SA.CrosstabDefaultCell({parent: this.childEl});
        this.metadataCell = new SA.CrosstabMetadataCell({parent: this.childEl});
    },

    onStateChange(state) {
        var loading = state.loading,
            loaded = !loading;

        this.loadingCell.setVisible(loading);
        this.defaultCell.setVisible(loaded && state.isDefaultMode);
        this.metadataCell.setVisible(loaded && !state.isDefaultMode);

        if (loading) {
            this.loadingCell.setState(state);
        }
        else {
            this.defaultCell.setState(state);
            this.metadataCell.setState(state);
        }
    }
});